module.exports = __webpack_public_path__ + "img/cp10.f610d57c.png";